function DashboardPage() {
  const stats = [
    { label: 'Active caregivers', value: '128' },
    { label: 'Pending approvals', value: '7' },
    { label: 'Requests today', value: '42' },
  ];

  const updates = [
    'Shift swaps have increased by 12% this week.',
    'Security review scheduled for Friday at 10:00 AM.',
    'New staff onboarding cohort starts Monday.',
  ];

  return (
    <div className="space-y-8">
      <header className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.5em] text-emerald-500">Carewinners Admin</p>
          <h1 className="text-3xl font-semibold text-slate-900">Dashboard</h1>
          <p className="text-slate-600">
            Everything you need to keep the team safe and schedules flowing.
          </p>
        </div>
        <button
          type="button"
          className="rounded-2xl border border-emerald-300 px-5 py-2 text-sm font-semibold text-emerald-700 hover:border-emerald-500"
        >
          Export report
        </button>
      </header>

      <section className="grid gap-6 md:grid-cols-3">
        {stats.map((stat) => (
          <article
            key={stat.label}
            className="rounded-3xl border border-emerald-100 bg-emerald-50/70 p-6 shadow-lg shadow-emerald-200/40"
          >
            <p className="text-xs uppercase tracking-[0.4em] text-emerald-600">{stat.label}</p>
            <p className="text-3xl font-semibold text-emerald-900">{stat.value}</p>
          </article>
        ))}
      </section>

      <section className="rounded-3xl border border-emerald-100 bg-white p-6">
        <h2 className="text-xl font-semibold text-slate-900">Live updates</h2>
        <ul className="mt-4 space-y-3 text-slate-600">
          {updates.map((message) => (
            <li key={message} className="rounded-2xl border border-emerald-100 bg-emerald-50/70 px-4 py-3">
              {message}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default DashboardPage;
